/**
 * @generated SignedSource<<baa98ce6c0393cc8142718d7d0abb1c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GlobalTopNavigationView$data = {
  readonly profile: {
    readonly " $fragmentSpreads": FragmentRefs<"Profile_AtlassianGlobalTopNavigation">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"AppHome" | "AppSwitcher" | "Notifications">;
  readonly " $fragmentType": "GlobalTopNavigationView";
};
export type GlobalTopNavigationView$key = {
  readonly " $data"?: GlobalTopNavigationView$data;
  readonly " $fragmentSpreads": FragmentRefs<"GlobalTopNavigationView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "GlobalTopNavigationView",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "AppHome"
    },
    {
      "kind": "FragmentSpread",
      "name": "AppSwitcher"
    },
    {
      "kind": "FragmentSpread",
      "name": "Notifications"
    },
    {
      "fragment": {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Profile_AtlassianGlobalTopNavigation"
          }
        ],
        "type": "Query"
      },
      "kind": "AliasedInlineFragmentSpread",
      "name": "profile"
    }
  ],
  "type": "Query"
};

(node as any).hash = "4c88cf80b05dace5479c998fb1446f80";

export default node;
